import type { FaireProductEntity } from "../../entity_types/product";

export const p_9n6mp50z67: FaireProductEntity = {
  token: "p_9n6mp50z67",
  type: "product",
  name: "135 oz Oneka Cedar and Sage Shampoo",
  brandToken: "b_728onxgxav",
  brandName: "Oneka",
  imageUrl:
    "https://cdn.faire.com/fastly/139310271b45783d7696de38f92bb05968895eee2cec5222b6082835967cfce2.jpeg",
  galleryImageUrls: [],
  priceDollars: 58,
  description:
    "Our Oneka cedar and sage shampoo is conscientiously formulated with essential oils and extracts from our organic wild plants carefully selected for their tonic, nourishing, and pH balancing properties. Breathe in the earthy scent and enjoy our cedar and sage shampoo, specially formulated to help revitalize your scalp. The antibacterial properties of the cedar will be absorbed into the hair for a deep cleansing EFFECT while sage is known to help balance sebum.\nHave a positive impact on the environment by reducing the use of plastic. Refill your 16.5 oz bottles 8 times at home with our 4 Litre (135 oz) product. \n*135 oz pumps sold separately.",
  tags: [],
  msrpDollars: 91,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:54.726Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
